import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Checkbox: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50515 1.5C1.95003 1.5 1.5 1.95002 1.5 2.50515V13.4948C1.5 14.05 1.95002 14.5 2.50515 14.5H13.4948C14.05 14.5 14.5 14.05 14.5 13.4948V2.50515C14.5 1.95003 14.05 1.5 13.4948 1.5H2.50515ZM3.10825 12.8918V3.10825H12.8918V12.8918H3.10825Z"
          fill="currentColor"
        />
        <path
          d="M10.5 5.25535L11.8333 6.45535L6.99999 10.9553L4.33332 8.55533L5.66665 7.35532L7 8.55534L10.5 5.25535Z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};
Checkbox.displayName = 'Checkbox';

export default Checkbox;
